import { styled } from '@mui/material/styles';

export const CountryFlag = styled('img')(({ theme }) => ({
  display: 'inline',
  margin: theme.spacing(0, 2, 0, 1),
}));
